import React from 'react';
import {useAuth} from '../../contexts/AuthContext';

interface TenantAvatarProps {
    name?: string;
    email?: string;
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}

// Bảng màu cố định - cùng một người luôn ra cùng một màu, dễ nhận ra trong danh sách
const PALETTE = [
    'bg-slate-500/15 text-slate-600 dark:text-slate-300',
    'bg-sky-500/15 text-sky-600 dark:text-sky-300',
    'bg-slate-500/15 text-slate-600 dark:text-slate-300',
    'bg-amber-500/15 text-amber-600 dark:text-amber-300',
    'bg-rose-500/15 text-rose-600 dark:text-rose-300',
    'bg-violet-500/15 text-violet-600 dark:text-violet-300',
];

const SIZES = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base',
};

const toneOf = (seed: string): string => {
    let hash = 0;
    for (let i = 0; i < seed.length; i++) {
        hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
    }
    return PALETTE[hash % PALETTE.length];
};

const initialsOf = (name?: string, email?: string): string => {
    const source = (name || email || '?').trim();
    const words = source.split(/\s+/).filter(Boolean);
    if (words.length >= 2) {
        // Tên tiếng Việt: lấy chữ cái của tên gọi (từ cuối) + họ cho dễ phân biệt
        return (words[words.length - 2][0] + words[words.length - 1][0]).toUpperCase();
    }
    return source.slice(0, 2).toUpperCase();
};

/**
 * Ảnh đại diện người thuê.
 *
 * Ảnh Google thật chỉ lấy được cho CHÍNH tài khoản đang đăng nhập (photoURL nằm
 * trong token, không lưu trong DB). Người khác trong phòng hiển thị chữ cái đầu
 * trên nền màu suy ra từ email - không cần thêm dữ liệu, không gọi mạng ngoài.
 */
export const TenantAvatar: React.FC<TenantAvatarProps> = ({name, email, size = 'md', className = ''}) => {
    const {user} = useAuth();
    const isSelf = !!email && !!user?.email && email.trim().toLowerCase() === user.email.toLowerCase();
    const base = `${SIZES[size]} rounded-full flex items-center justify-center font-semibold flex-shrink-0 ${className}`;

    if (isSelf && user?.photoURL) {
        return <img src={user.photoURL} alt="" className={`${base} object-cover`}/>;
    }

    return (
        <span className={`${base} ${toneOf(email || name || '?')}`}>
            {initialsOf(name, email)}
        </span>
    );
};
